"use strict";
// generated-supplemental-tape.d.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = exports.PassThroughSchema = void 0;
const zod_1 = require("zod");
const tasks_1 = require("../../tasks");
// Shared description for the pass-through flag, reused by the UI (optional) and
// the persisted DB record (required) so both layers stay in sync.
const passThroughDescription = 'When true, the node copies its single input straight through and IGNORES the configured operation (legacy behavior). When false, the configured operation (e.g. sanitize) runs at execution time. Existing nodes are migrated to true to preserve their historical pass-through behavior; only new/edited nodes get the sanitizing default.';
// Required in the persisted record: every stored/committed node must make an
// explicit choice so the runtime never has to guess whether to run the op.
exports.PassThroughSchema = zod_1.z.boolean().describe(passThroughDescription);
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    // Optional in the UI (a new node need not think about it); conversion
    // defaults an unset flag to the new sanitizing behavior (false).
    passThrough: exports.PassThroughSchema.optional(),
});
exports.nodeType = 'file_generatedSupplementalTape';
// The runtime/persisted config for a supplemental tape is its operation task
// plus the required `passThrough` flag. Shared with the DB-layer node schema
// (`dbNodes/generatedSupplementalTape/node.ts`) so both stay in sync.
exports.IntermediateRecordConfigSchema = tasks_1.TapeBuilderTaskSchema.and(zod_1.z.object({ passThrough: exports.PassThroughSchema }));
exports.artifactType = 'generatedSupplementalTape';
//# sourceMappingURL=types.js.map